<style scoped>

.chart-parameters {
    min-height: 800px;
}
.echarts {
  width: 100%;
  height: 550px;
}
</style>

<template>
<v-container grid-list-xs fluid class='chart-parameters'>
<!--v-if='chart.chartData.valid'-->
  <!--<echart :options="calendarOption" />-->
  <apexchart v-if="chart.type == 'line.apexchart'" type="line" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'area.apexchart' " type="area" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'bar.apexchart'" type="bar" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'mixed.apexchart'" type="line" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'heatmap.apexchart'" type="heatmap" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'scatter.apexchart'" type="scatter" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'pie.apexchart'" type="pie" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'donut.apexchart'" type="donut" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
  <apexchart v-if="chart.type == 'radial.apexchart'" type="radialBar" :height="chart.chartData.height" :options="chart.chartData.options" :series="chart.chartData.series" />
</v-container>

</template>

<script>

import {
    createNamespacedHelpers
}
from 'vuex';
/**
import echarts from 'echarts/'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pictorialBar'
import 'echarts/lib/component/polar'
**/
/**
import 'echarts/echarts.all'**/

// has mapState, mapActions, mapGetters, mapMutations
const dataSourceNamespace = createNamespacedHelpers('dataSources');
const chartNamespace = createNamespacedHelpers('charts');

function resolve(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
}

export default {
    data: function() {
      return {};
    },
    methods: {

    },
    computed: {
        ...dataSourceNamespace.mapState(['dataSources']),
            ...chartNamespace.mapState({
                chart: state => state.chart,
                charts: state => state.charts,
                parameters: state => state.chart.parameters
            })
    },
    components: {

    },
    mounted: function() {
      this.chart.instance = this.$refs.chartDemo;
      // console.log(this.$refs.chartDemo);
      // this.loadDataSources();
    }
}

</script>
